import { Component, ReactNode } from 'react'
import { connect } from 'react-redux'

import { DispatchProp } from 'modules/store'

import { isEmpty, isFunction } from '../../shared'
import { State } from '../../store'

import { User } from '../models'
import * as fromStore from '../store'

const mapStateToProps = (state: State) => ({
  user: fromStore.getUser(state),
})

const enhance = connect(mapStateToProps)

export type Props = {
  render?: RenderProp
  children?: RenderProp
} & InjectedProps &
  DispatchProp

type InjectedProps = { user: User }
type RenderProp = (user: User) => ReactNode
class CurrentUser extends Component<Props> {
  render() {
    const { render = this.props.children, user } = this.props

    if (!isFunction(render)) {
      throw new Error(`CurrenUser: render prop or children as a function is required`)
    }

    return render(user)
  }

  componentWillMount() {
    const { user, dispatch } = this.props
    isEmpty(user) && dispatch(new fromStore.actions.CurentUserAction())
  }
}

export default enhance(CurrentUser)



// WEBPACK FOOTER //
// ./src/app/auth/components/current-user.tsx